export default __webpack_public_path__ + "static/media/mercedesbenz.821df50d.png";